<template>
  <tk-breadcrumbs :items="itemsWithFixedOnes" />
</template>

<script>
import { TkBreadcrumbs } from '@ota-frontend/ui'
import { SearchCondition } from '@/models'

export default {
  name: 'Breadcrumbs',
  components: {
    TkBreadcrumbs,
  },
  props: {
    condition: {
      type: SearchCondition,
      required: true,
    },
  },
  computed: {
    itemsWithFixedOnes() {
      if (!this.condition.domesticFlagIsSpecified) {
        return this.fixedItemsForNotExistsDomestic
      }

      return this.condition.isDomestic
        ? [...this.fixedItemsForDomesticTour, ...this.items]
        : [...this.fixedItemsForAbroadTour, ...this.items]
    },
    fixedItemsForAbroadTour() {
      return [{
        name: '海外旅行・国内旅行の旅工房',
        url: '/',
      }, {
        name: '海外ツアー',
        url: '/tour/',
      }, {
        name: '検索結果',
        url: '/tour/tourresult',
      }]
    },
    fixedItemsForDomesticTour() {
      return [{
        name: '海外旅行・国内旅行の旅工房',
        url: '/',
      }, {
        name: '国内旅行',
        url: '/japan/',
      }, {
        name: '国内ツアー',
        url: '/japan/tour/',
      }]
    },
    fixedItemsForNotExistsDomestic() {
      return [{
        name: '海外旅行・国内旅行の旅工房',
        url: '/',
      }, {
        name: '検索結果',
        url: '/tour/tourresult',
      }]
    },
    items() {
      if(!this.condition.isDomestic) return []

      const items = [this.countryPart, this.cityPart].filter(Boolean)
      return items.length > 0
        ? items
        : [{ name: '検索結果', url: '/tour/tourresult' }]
    },
    countryPart() {
      const country = this.condition.primaryDestinationCountry
      return country
        ? {
          name: country.country_name_ja || '',
          url: `/japan/tour/${country.country_name_en || ''}`,
        }
        : null
    },
    cityPart() {
      const name = this.condition.primaryDestinationCity && this.condition.primaryDestinationCity.city_name_ja
      if (!name) return null

      const path = this.condition.primaryDestinationCity.city_name_en || ''

      // １都市名に複数名称が含まれていることがある
      const names = name.split('・')
      const paths = path.split(',')
      // 都市名「那覇・首里」の時にキーワード「那覇」が指定された場合は「那覇」をパンくずとして表示する
      const [nameByKeyword, pathByKeyword] = (index =>
        index >= 0
          ? [names[index], paths[index]]
          : []
      )(names.findIndex(name => name === this.condition.keyword))
      const countryPath = this.condition.primaryDestinationCountry && this.condition.primaryDestinationCountry.country_name_en || ''

      if (nameByKeyword) {
        return {
          name: nameByKeyword,
          url: `/japan/tour/${countryPath}/${pathByKeyword}`,
        }
      }
      if (paths.length > 1) {
        return {
          name,
          url: `/japan/tour/${countryPath}/${paths[0]}-region`,
        }
      }
      return {
        name,
        url: `/japan/tour/${countryPath}/${path}`,
      }
    },
  }
}
</script>
